"use strict";

exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pizzip/js/defaults.js
// module id = GDDx
// module chunks = 5